import { __makeTemplateObject, __awaiter, __generator } from '../node_modules/tslib/tslib.es6.js';
import React from 'react';
import usePlacesAutocomplete, { getGeocode } from 'use-places-autocomplete';
import styled from 'styled-components';
import SearchDropdown, { SearchDropdownTypes } from './SearchDropdown.js';
import { IconEnum } from './Icons.js';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  z-index: 100000;\n"], ["\n  width: 100%;\n  z-index: 100000;\n"])));
function AddressSearchDropdown(_a) {
    var _this = this;
    var value = _a.value, onChange = _a.onChange, width = _a.width, label = _a.label, tip = _a.tip, fontSize = _a.fontSize, fontWeight = _a.fontWeight, fontFamily = _a.fontFamily, darkThemeProps = _a.darkThemeProps, labelColor = _a.labelColor, borderColor = _a.borderColor, height = _a.height;
    /* Hooks */
    var _b = usePlacesAutocomplete({
        requestOptions: {
            componentRestrictions: { country: "us" },
        },
        debounce: 300,
    }), innerValue = _b.value, data = _b.suggestions.data, setValue = _b.setValue;
    React.useEffect(function () {
        var placeName = (value === null || value === void 0 ? void 0 : value.placeName) ? value === null || value === void 0 ? void 0 : value.placeName : "";
        setValue(placeName);
        innerValue = placeName;
    }, []);
    var selectAddress = React.useCallback(function (address) {
        setValue(address);
        var doEffect = function () { return __awaiter(_this, void 0, void 0, function () {
            var results, result, location_1, addressObject_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getGeocode({ address: address })];
                    case 1:
                        results = _a.sent();
                        result = results.find(function (r) {
                            return r.address_components.length > 2 &&
                                r.types.includes('street_address');
                        }) || results[0];
                        location_1 = result.geometry.location;
                        addressObject_1 = {
                            address1: "",
                            address2: "",
                            city: "",
                            state: "",
                            zip: "",
                            country: "",
                            lat: location_1.lat(),
                            lng: location_1.lng(),
                            placeId: result.place_id,
                            placeName: address,
                        };
                        result.address_components.forEach(function (ac) {
                            if (ac.types.includes("street_number")) {
                                addressObject_1.address1 = ac.short_name;
                            }
                            if (ac.types.includes("route")) {
                                addressObject_1.address1 = addressObject_1.address1
                                    ? "".concat(addressObject_1.address1, " ").concat(ac.short_name).trim()
                                    : ac.short_name;
                            }
                            if (ac.types.includes("subpremise")) {
                                addressObject_1.address2 = ac.short_name;
                            }
                            if (ac.types.includes("locality") &&
                                ac.types.includes("political")) {
                                addressObject_1.city = ac.short_name;
                            }
                            if (ac.types.includes("administrative_area_level_1") &&
                                ac.types.includes("political")) {
                                addressObject_1.state = ac.short_name;
                            }
                            if (ac.types.includes("country") &&
                                ac.types.includes("political")) {
                                addressObject_1.country = ac.short_name;
                            }
                            if (ac.types.includes("postal_code")) {
                                addressObject_1.zip = ac.short_name;
                            }
                        });
                        onChange(addressObject_1);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        doEffect();
    }, [onChange, setValue]);
    React.useEffect(function () {
        var intialAddress = {};
        if (!innerValue)
            onChange(intialAddress);
    }, [innerValue]);
    /* Render */
    var items = [];
    if (data.length) {
        items = data.map(function (suggestion) { return ({
            text: suggestion.description,
            value: suggestion.description,
        }); });
    }
    return (React.createElement(Container, null,
        React.createElement(SearchDropdown, { type: SearchDropdownTypes.SingleSelect, icon: IconEnum.MapPinLight, onChange: selectAddress, value: innerValue, searchQuery: innerValue, setSearchQuery: setValue, placeholder: "Search for an address", items: items, width: width, label: label, tip: tip, fontSize: fontSize, fontWeight: fontWeight, fontFamily: fontFamily, darkThemeProps: darkThemeProps, labelColor: labelColor, borderColor: borderColor, height: height })));
}
var templateObject_1;

export { AddressSearchDropdown as default };
//# sourceMappingURL=AddressSearchDropdown.js.map
